export default "__VITE_ASSET__CUejyC0z__"